import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import FileUploader from '../../onboarding/studentDetails/fileUpload';
import CommonButton from '../../CommonButton/CommonButton';
import styles from "../offlinePay.module.css";
import { documentUploadApi } from '../../../api';
import { useMyContext } from '../../../myContext';

function OfflineStudentDocs({stepToShowOffline, setStepToShowOffline}) {
    const [loading, setLoading] = useState(false);
    const [passportFrontFile, setPassportFront] = useState(null);
    const [passportBackFile, setPassportBack] = useState(null);
    const [passportFrontFileType, setPassportFrontFileType] = useState(null);
    const [passportBackFileType, setPassportBackFileType] = useState(null);
    const acceptedFormats = ".jpeg, .jpg, .png .pdf";
    const {offlineStudentUserId} = useMyContext();

    const checkValidFile = (files) => {
      if (
        files.filter(
          (file) =>
            acceptedFormats.includes(file.type) ||
            acceptedFormats.includes(`.${file.name.split(".").pop()}`)
        )
      ) {
        return true;
      } else {
        return false;
      }
    };

    const handleFrontPassportDrop = (files) => {
      if (checkValidFile(files)) {
        setPassportFront(files[0]);
        const fileExtension = files[0].name.split(".").pop();
        setPassportFrontFileType(fileExtension);
      }
    };
  
    const handleBackPassportDrop = (files) => {
      if (checkValidFile(files)) {
        setPassportBack(files[0]);
        const fileExtension = files[0].name.split(".").pop();
        setPassportBackFileType(fileExtension);
      }
    };

    const uploadFile = async (file, fileType, docType, side) => {
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await documentUploadApi(
          offlineStudentUserId,
          fileType,
          docType,
          side,
          formData
        );
      } catch (error) {
        throw error;
      }
    };

    const frontPassportApi = () =>
      uploadFile(passportFrontFile, passportFrontFileType, "PASSPORT", "front");
    const backPassportApi = () =>
      uploadFile(passportBackFile, passportBackFileType, "PASSPORT", "back");
  
    const handleSuccess = () => {
        setStepToShowOffline(5);
    };


    const checkIfValid = async () => {
      if (passportBackFile !== undefined && passportFrontFile !== undefined) {
        try {
          setLoading(true);
          Promise.all([
            frontPassportApi(),
            backPassportApi()
          ]).then(() => {
            handleSuccess();
              setLoading(false);
          });
      }catch (error) {
        setLoading(false);
        }
      }
    };

    const onRemoveButton = (label) => {
      if (label === "Front of Passport") {
        setPassportFront(null);
        setPassportFrontFileType("");
      } else if (label === "Back of Passport") {
        setPassportBack(null);
        setPassportBackFileType("");
      }
    };
  
    return (
      <Card className={styles.cardAccount}>
        <Card.Body className={styles.cardBodyAccount}>
          <Row className={styles.Title}>Documents Upload</Row>
          {stepToShowOffline >= 4 ? (
            <>
              <hr style={{ marginTop: "0px" }} />
              <div style={{ marginTop: "20px" }}>
                <Row style={{ marginBottom: "8px", justifyContent: "center" }}>
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    lg={4}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "10px 0px",
                    }}
                  >
                    <FileUploader
                      onDrop={handleFrontPassportDrop}
                      acceptedFormats={acceptedFormats}
                      maxSize={5000000}
                      label="Front Passport"
                      loading={loading || stepToShowOffline !== 4}
                      showRemove={stepToShowOffline === 4}
                      onRemoveButton={() => onRemoveButton("Front of Passport")}
                    />
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    xs={12}
                    lg={4}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "10px 0px",
                    }}
                  >
                    <FileUploader
                      onDrop={handleBackPassportDrop}
                      acceptedFormats={acceptedFormats}
                      maxSize={5000000}
                      label="Back Passport"
                      loading={loading || stepToShowOffline !== 4}
                      showRemove={stepToShowOffline === 4}
                      onRemoveButton={() => onRemoveButton("Back of Passport")}
                    />
                  </Col>
                </Row>
              </div>
              {stepToShowOffline === 4 && <><Row className={styles.allowedFormat}>
                Allowed Formats are jpeg, png, jpg, pdf and the size should be
                less then 5MB
              </Row>
              <Row className={styles.allowedFormat} style={{marginTop: "2px", color: "red", fontSize: "12px"}}>
            Please ensure the documents uploaded for Proof of Identity are accurate.
            </Row></>}
              {stepToShowOffline === 4 && <Row className="pt-3 mt-3">
                <Col md={3}>
                  <CommonButton
                    title="Next"
                      onClick={checkIfValid}
                      loading={loading}
                      disabled={loading || passportBackFile === null || passportFrontFile === null}
                    width={"150px"}
                  />
                </Col>
              </Row>}
            </>
          ) : (
            ""
          )}
        </Card.Body>
      </Card>
    );
}

export default OfflineStudentDocs